import { useTranslation } from "react-i18next";
import { useState, useRef, useEffect } from "react";

import { List } from "antd";
import { Check, Dot } from "lucide-react";

import { motion } from "framer-motion";

import { CardBlog } from "../../../components";
import { getblogs } from "../../../services/blog";

import QR_CODE_SOKO from "../../../assets/soko_qr.jpg";
import LOGO_SOKO from "../../../assets/common/logo_soko_01.png";
// import SOKO_THUMBNAIL from "../../../assets/Home_Services_03.jpg";
import SOCIAL_RESPONSIBILITY_01 from "../../../assets/Blog/social_reponsibility_01.png";
import SOCIAL_RESPONSIBILITY_02 from "../../../assets/Blog/social_reponsibility_02.png";
import SOCIAL_RESPONSIBILITY_03 from "../../../assets/Blog/social_reponsibility_03.png";
import SOCIAL_RESPONSIBILITY_04 from "../../../assets/Blog/social_reponsibility_04.png";
import SOCIAL_RESPONSIBILITY_05 from "../../../assets/Blog/social_reponsibility_05.png";
import SOCIAL_RESPONSIBILITY_06 from "../../../assets/Blog/social_reponsibility_06.png";
import SOCIAL_RESPONSIBILITY_07 from "../../../assets/Blog/social_reponsibility_07.png";

const Blog = () => {
  const { t, i18n } = useTranslation();

  const currentLang = i18n.language;

  const pagesize = 6;

  const [BlogsData, setBlogsData] = useState([]);

  const [totalBlogs, settotalBlogs] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [isloadingdata, setIsloadingData] = useState(false);

  const blogRef = useRef(true);
  const isFirstRender = useRef(true);

  const getAllBlogs = async () => {
    setIsloadingData(true);

    try {
      const res = await getblogs(currentPage, pagesize);

      const validBlogs = res.data.filter(
        (item) => item.content && item.title && item.thumbnail
      ); // Lọc các mục hợp lệ
      setBlogsData(validBlogs);
      // settotalBlogs(res.metadata.totalBlog);
      settotalBlogs(validBlogs.length); // Cập nhật state với dữ liệu hợp lệ

      setIsloadingData(false); // Tắt trạng thái loading
    } catch (err) {
      console.error(err.message);

      setIsloadingData(false); // Tắt trạng thái loading trong trường hợp lỗi
    }
  };

  useEffect(() => {
    getAllBlogs();
  }, [currentPage]);

  useEffect(() => {
    if (!isFirstRender.current) {
      if (blogRef.current) {
        blogRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [currentPage]);

  const fadeInUp = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0 },
  };

  const fadeIn = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const socialResponsibilities = [
    {
      id: 0,
      title: t("social_repsonsibility_section_01_title"),
      content: t("social_repsonsibility_section_01_content"),
    },
    {},
    {
      id: 1,
      title: t("social_repsonsibility_section_02_title"),
      content: t("social_repsonsibility_section_02_content"),
    },
    {
      id: 2,
      title: t("social_repsonsibility_section_03_title"),
      content: t("social_repsonsibility_section_03_content"),
    },
    {},
    {
      id: 3,
      title: t("social_repsonsibility_section_04_title"),
      content: t("social_repsonsibility_section_04_content"),
    },
    {
      id: 4,
      title: t("social_repsonsibility_section_05_title"),
      content: t("social_repsonsibility_section_05_content"),
    },
    {},
    {
      id: 5,
      title: t("social_repsonsibility_section_06_title"),
      content: t("social_repsonsibility_section_06_content"),
    },
  ];

  const SocialResponsibilityBanner = () => {
    return (
      <div
        className={
          "relative lg:absolute lg:left-1/2 lg:-translate-x-1/2 lg:top-1/2 lg:-translate-y-1/2"
        }
      >
        <img
          src={SOCIAL_RESPONSIBILITY_01}
          alt={SOCIAL_RESPONSIBILITY_01}
          className={
            "object-cover absolute left-1/2 -translate-x-1/2 hidden lg:block lg:relative lg:w-[300px] lg:max-xl:w-[220px] xl:max-dv:w-[280px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_02}
          alt={SOCIAL_RESPONSIBILITY_02}
          className={
            "object-cover w-[40px] absolute top-0 left-[-24px] hidden md:w-[52px] md:left-0 lg:block lg:w-[40px] lg:left-[-36px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_03}
          alt={SOCIAL_RESPONSIBILITY_03}
          className={
            "object-cover w-[40px] absolute top-0 right-[-24px] hidden md:right-0 md:w-[52px] lg:block lg:w-[40px] lg:right-[-36px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_04}
          alt={SOCIAL_RESPONSIBILITY_04}
          className={
            "object-cover w-[40px] absolute top-[140px] left-[-20px] hidden md:top-[210px] md:left-[24px] md:w-[52px] lg:block lg:w-[40px] lg:max-xl:left-[-2px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_05}
          alt={SOCIAL_RESPONSIBILITY_05}
          className={
            "object-cover w-[40px] absolute top-[140px] right-[-20px] hidden md:top-[210px] md:right-[24px] md:w-[52px] lg:block lg:w-[40px] lg:max-xl:right-[-2px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_06}
          alt={SOCIAL_RESPONSIBILITY_06}
          className={
            "object-cover w-[40px] absolute bottom-[-440px] left-[90px] hidden md:bottom-[-560px] md:w-[52px] lg:block lg:bottom-[-60px] lg:w-[40px] lg:max-xl:left-[60px] lg:max-xl:bottom-[-100px]"
          }
        />

        <img
          src={SOCIAL_RESPONSIBILITY_07}
          alt={SOCIAL_RESPONSIBILITY_07}
          className={
            "object-cover w-[40px] absolute bottom-[-440px] right-[90px] hidden md:bottom-[-560px] md:w-[52px] lg:block lg:bottom-[-60px] lg:w-[40px] lg:max-xl:right-[60px] lg:max-xl:bottom-[-100px]"
          }
        />
      </div>
    );
  };

  const SocialResponsibility = (title, content) => {
    return (
      <div className={"w-full flex flex-col space-y-2"}>
        <h3 className={"text-[20px] text-[#F7941D] font-semibold"}>{title}</h3>
        <p className={"w-full text-[16px] text-primary text-justify"}>
          {content}
        </p>
      </div>
    );
  };

  const SunneyPearlSocialResponsibility = () => {
    return (
      <div className={"relative flex flex-col space-y-4"}>
        <div className={"flex justify-center"}>
          <img
            src={SOCIAL_RESPONSIBILITY_01}
            alt={SOCIAL_RESPONSIBILITY_01}
            className={"block w-[200px] md:w-[250px] lg:hidden"}
          />
        </div>

        <h2
          className={
            "text-[24px] space-x-2 font-semibold text-primary flex flex-nowrap lg:text-[32px] lg:flex lg:justify-center lg:items-center"
          }
        >
          <span>{"SUNNY"}</span>
          <span className={"text-[#2872BC]"}>{"PEARL"}</span>
          <span
            className={"text-nowrap"}
          >{`- ${t("social_repsonsibility_header_part_01")} -`}</span>
          <span className={"text-[#F7941D] text-nowrap"}>
            {t("social_repsonsibility_header_part_02")}
          </span>
        </h2>

        <div
          className={"grid grid-cols-1 space-y-4 lg:grid-cols-3 lg:space-y-0"}
        >
          {socialResponsibilities.map((responsibility) => {
            return SocialResponsibility(
              responsibility.title,
              responsibility.content
            );
          })}
        </div>

        {SocialResponsibilityBanner()}
      </div>
    );
  };

  return (
    <div
      className={
        "max-w-[1140px] w-[85%] qhd:max-w-[60%] mx-auto gap-10 pt-10 flex flex-col"
      }
    >
      <motion.div
        initial={"hidden"}
        animate={"visible"}
        variants={fadeInUp}
        transition={{ duration: 0.5 }}
        className={"flex flex-col items-center justify-center space-y-10 mb-20"}
      >
        <div className={"flex flex-col items-center justify-center space-y-2"}>
          <div>
            <img
              src={LOGO_SOKO ?? ""}
              alt={LOGO_SOKO ?? ""}
              className={"w-[160px] object-cover"}
            />
          </div>
          <h1 className="text-[1.725rem] text-primary text-center">
            <span>
              {"SEEDS OF KNOWLEDGE & OPPORTUNITIES"
                .split(" ")
                .map((word, index) => {
                  const firstChar = word.charAt(0);
                  const isLetter = /^[A-Za-z]$/.test(firstChar);

                  return (
                    <span key={index}>
                      {isLetter ? (
                        <>
                          <span className="font-bold">{firstChar}</span>
                          {word.slice(1)}
                        </>
                      ) : (
                        word
                      )}{" "}
                    </span>
                  );
                })}
              
                      
                    
               
              </span>
            
            <span>{"("}</span>
            <span className={"font-bold"}>{"SOKO"} </span>
            <span>{"FOUNDATION)"}</span>
          </h1>
          {currentLang === "vi" ? (
            <p className="text-[1.625rem] text-teal text-center md:text-left">
              {t("blog_sub_header")}
            </p>
          ) : null}
        </div>

        <div className={"flex flex-col items-center justify-center space-y-2"}>
          <h2
            className={"mt-4 text-[2.5rem] text-primary font-bold text-center"}
          >
            {t("blog_title_01")}
          </h2>
          <p className={"text-[1.8rem] font-semibold text-center"}>
            {t("blog_title_01_content")}
          </p>
        </div>

        <div
          className={
            "w-full flex flex-col items-center justify-center space-y-2"
          }
        >
          <h2 className={"mt-4 text-[2.5rem] text-primary font-bold"}>
            {t("blog_title_02")}
          </h2>
          <p className={"text-[1.8rem] font-semibold"}>
            {t("blog_title_02_content")}
          </p>
          <div className={"w-full grid grid-cols-1 md:grid-cols-2"}>
            <div className={"col-span-1"}>
              <h3
                className={"text-teal font-semibold text-[1.6rem] text-center"}
              >
                {t("blog_title_02_sub_table_title_01")}
              </h3>
              <div className={"text-[1.2rem] text-center"}>
                <p>{t("blog_title_02_sub_table_01_content_01")}</p>
                <p>{t("blog_title_02_sub_table_01_content_02")}</p>
                <p>{t("blog_title_02_sub_table_01_content_03")}</p>
                <p>{t("blog_title_02_sub_table_01_content_04")}</p>
                <p>{t("blog_title_02_sub_table_01_content_05")}</p>
                <p>{t("blog_title_02_sub_table_01_content_06")}</p>
              </div>
            </div>
            <div className={"col-span-1"}>
              <h3
                className={"text-teal font-semibold text-[1.6rem] text-center"}
              >
                {t("blog_title_02_sub_table_title_02")}
              </h3>
              <ul
                className={"text-[1.2rem] flex flex-col space-y-2 text-justify"}
              >
                <li className={"flex"}>
                  <span>
                    <Dot size={32} />
                  </span>
                  <span>{t("blog_title_02_sub_table_02_content_01")}</span>
                </li>
                <li className={"flex"}>
                  <span>
                    <Dot size={32} />
                  </span>
                  <span>{t("blog_title_02_sub_table_02_content_02")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div
          className={
            "flex flex-col items-center text-[2.5rem] font-bold md:flex-row md:space-x-2"
          }
        >
          <span className={"text-primary text-center"}>
            {t("blog_title_03_prefix")}
          </span>
          <span className={"text-teal text-center"}>
            {t("blog_title_03_suffix")}
          </span>
        </div>

        <div className={"flex flex-col space-y-4"}>
          <div
            className={
              "float-left space-x-2 text-[2.5rem] font-bold text-center"
            }
          >
            <span className={"flex-1 text-primary"}>
              {t("blog_title_04_prefix")}
            </span>
            <span className={"text-teal"}>{t("blog_title_04_suffix")}</span>
          </div>
          <ul className={"text-[1.2rem] flex flex-col space-y-4 text-justify "}>
            <li className={"flex"}>
              <span>
                <Dot size={32} className={"text-teal"} />
              </span>
              <span>{t("blog_title_04_content_01")}</span>
            </li>
            <li className={"flex"}>
              <span>
                <Dot size={32} className={"text-teal"} />
              </span>
              <span>{t("blog_title_04_content_02")}</span>
            </li>
            <li className={"flex"}>
              <span>
                <Dot size={32} className={"text-teal"} />
              </span>
              <span>{t("blog_title_04_content_03")}</span>
            </li>
            <li className={"flex flex-col space-y-4"}>
              <div className={"flex"}>
                <span>
                  <Dot size={32} className={"text-teal"} />
                </span>
                <span>{t("blog_title_04_content_04")}</span>
              </div>
              <div className={"flex flex-col space-y-4 md:pl-20"}>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_04_sub_content_01")}</span>
                </p>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_04_sub_content_02")}</span>
                </p>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_04_sub_content_03")}</span>
                </p>
              </div>
              <div className={"flex items-center justify-center"}>
                <img
                  src={QR_CODE_SOKO ?? ""}
                  alt={QR_CODE_SOKO ?? ""}
                  className={"object-cover w-[320px]"}
                />
              </div>
            </li>
            <li className={"flex flex-col space-y-4"}>
              <div className={"flex"}>
                <span>
                  <Dot size={32} className={"text-teal"} />
                </span>
                <span>{t("blog_title_04_content_05")}</span>
              </div>
              <div className={"flex flex-col space-y-4 md:pl-20"}>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_05_sub_content_01")}</span>
                </p>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_05_sub_content_02")}</span>
                </p>
                <p className={"flex space-x-4"}>
                  <span>
                    <Check size={24} className={"text-teal"} />
                  </span>
                  <span>{t("blog_title_04_content_05_sub_content_03")}</span>
                </p>
              </div>
            </li>
          </ul>
        </div>
      </motion.div>

      {SunneyPearlSocialResponsibility()}

      {/* <h2 className={"text-[2.5rem] font-bold text-primary uppercase"}>
            {t("HeaderBlog")}
          </h2> */}

      {/* <div className={"h-[460px] md:hidden"}></div> */}

      <motion.div
        initial="hidden"
        animate="visible"
        variants={fadeIn}
        transition={{ duration: 0.5, delay: 0.3 }}
      >
        {BlogsData?.length > 0 ? (
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 1,
              md: 2,
              lg: 2,
              xl: 3,
              xxl: 3,
            }}
            loading={isloadingdata}
            pagination={{
              position: "bottom",
              align: "center",
              pageSize: pagesize,
              total: totalBlogs,
              onChange: (e) => {
                setCurrentPage(e);
              },
            }}
            dataSource={BlogsData}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <CardBlog
                  id={item.id}
                  content={item.content}
                  creator_avatar={item.creator_avatar}
                  creator={item.creator}
                  category={item.category}
                  thumbnail={item.thumbnail}
                  title={item.title}
                  subtitle={item?.subtitle}
                />
              </List.Item>
            )}
          />
        ) : (
          <div>{"No data"}</div>
        )}
      </motion.div>
    </div>
  );
};

export default Blog;
